const statusesAvailableForEdit = ["LOG", "ACC", "PROCESS"];
const isAvailableEditByStatus = (data) =>
  statusesAvailableForEdit.includes(data.reqStatusCode);

export const isCovidVac = {
  label: "Covid Vaccinated",
  type: "select",
  options: [
    { value: 1, label: "Yes", shortKeyCode: "y" },
    { value: "0", label: "No", shortKeyCode: "n" },
  ],
  fieldVisibilityAccessorByLoadedData: (d) => isAvailableEditByStatus(d),
  value: "0",
};
export const famHistT2DCode = {
  label: "Family history of type 2 diabetes",
  type: "autocomplete",
  resource: "lovs/FAMHISTT2D",
  fieldVisibilityAccessorByLoadedData: (d) => isAvailableEditByStatus(d),
  accessor: (d) => ({ value: d.famHistT2DCode, label: d.famHistT2DDesc }),
  value: "0",
  // Allow this field's label to wrap normally without affecting others
  // inputWrapStyles:
  //   "white-space: normal !important; label { white-space: normal !important; }",
};
export const isSelfT2DGest = {
  label: "Personal HX of T2D/Gest. Diabetes",
  type: "select",
  fieldVisibilityAccessorByLoadedData: (d) => isAvailableEditByStatus(d),
  options: [
    { value: 1, label: "Yes", shortKeyCode: "y" },
    { value: "0", label: "No", shortKeyCode: "n" },
  ],
  value: "0",
};